module.exports ={
    login: {
        company:'Minew',
        platform:'ESL Cloud',
        account:'口座番号',
        password:'パスワード',
        login:'ログイン',
        logining:'ログイン...',
        loginTip: {
            exist: 'ユーザーが存在しません',
            passwordErr: '間違ったパスワード',
            // permission:'プラットフォームを使用する権限がありません',
            permission:'管理者に連絡してストアを配置てください',
            msgErr:'ユーザー名またはパスワードが正しくありません',
            fail:'ログインできませんでした',
            storeClose: 'ストアは閉じています。管理者に連絡してください',
            storeExist: 'あなたの店は存在しません',
            valid: 'ユーザーが無効です。管理者に連絡してください',
            chooseSys: '管理者に連絡して、目的のアプリケーションシナリオを選択してください'
        },
        validMsg: {
            userName:'ユーザー名を入力してください',
            userNameRule: '文字または番号字を入力してください',
            length1:'6-20桁のパスワードを入力してください',
            // nameLen:'長さは20文字を超えることはできません'
            password:'ユーザーパスワードを入力してください',
            passRule:'ユーザーパスワードにスペースを含めることはできません',
            passRule1:'ユーザーパスワードに中国語を含めることはできません'
        },
        logoSrc: "/static/images/logo_en.png",
        chooseSysType: 'アプリケーションシナリオを選択してください',
        // sysTypeOpts: ['小売', '治療'],
        sysTypeOpts: [
            {
                label: '小売',
                value: 'retail'
            },{
                label: '治療',
                value: 'medical'
            },{
                label: 'カスタムシーン',
                value: 'custom'
            }
        ],
        sysTips: 'ヒント：このオプションは初めてのみ使用できます。目的のアプリケーションシナリオを選択してください',
        sure: '確定',
        cancel: 'キャンセル',
        chooseSysTip: {
            operateFail: 'シーンを選択できませんでした',
            exist: '選択したシーンは存在しません',
            choosed: '使用するシーンを選択しました。直接ログインしてください'
        },
        customLabel: 'シーンフィールド編集',
        labelEditLabel: {
            id: { zh: { label: 'id', value: 'ID' }, en: { label: 'id', value: 'ID' }, ja: { label: 'id', value: 'ID' } },
            barcode: { zh: { label: 'バーコード', value: '条形码' }, en: { label: 'バーコード', value: 'Barcode' }, ja: { label: 'バーコード', value: 'バーコード' } },
            qrcode: { zh: { label: 'QRコード', value: '二维码' }, en: { label: 'QRコード', value: 'Qrcode' }, ja: { label: 'QRコード', value: 'QRコード' } },
            label1: { zh: { label: 'フィールド1', value: '条形码文本' }, en: { label: 'フィールド1', value: 'Barcode Text' }, ja: { label: 'フィールド1', value: 'バーコードテキスト' } },
            label2: { zh: { label: 'フィールド2', value: '二维码文本' }, en: { label: 'フィールド2', value: 'Qrcode Text' }, ja: { label: 'フィールド2', value: 'QRコードテキスト' } },
            label3: { zh: { label: 'フィールド3', value: '预留1' }, en: { label: 'フィールド3', value: 'Placeholder1' }, ja: { label: 'フィールド3', value: '予約1' } },
            label4: { zh: { label: 'フィールド4', value: '预留2' }, en: { label: 'フィールド4', value: 'Placeholder2' }, ja: { label: 'フィールド4', value: '予約2' } },
            label5: { zh: { label: 'フィールド5', value: '预留3' }, en: { label: 'フィールド5', value: 'Placeholder3' }, ja: { label: 'フィールド5', value: '予約3' } },
            label6: { zh: { label: 'フィールド6', value: '预留4' }, en: { label: 'フィールド6', value: 'Placeholder4' }, ja: { label: 'フィールド6', value: '予約4' } },
            label7: { zh: { label: 'フィールド7', value: '预留5' }, en: { label: 'フィールド7', value: 'Placeholder5' }, ja: { label: 'フィールド7', value: '予約5' } },
            label8: { zh: { label: 'フィールド8', value: '预留6' }, en: { label: 'フィールド8', value: 'Placeholder6' }, ja: { label: 'フィールド8', value: '予約6' } },
            label9: { zh: { label: 'フィールド9', value: '预留7' }, en: { label: 'フィールド9', value: 'Placeholder7' }, ja: { label: 'フィールド9', value: '予約7' } },
            label10: { zh: { label: 'フィールド10', value: '预留8' }, en: { label: 'フィールド10', value: 'Placeholder8' }, ja: { label: 'フィールド10', value: '予約8' } },
            label11: { zh: { label: 'フィールド11', value: '预留9' }, en: { label: 'フィールド11', value: 'Placeholder9' }, ja: { label: 'フィールド11', value: '予約9' } },
            label12: { zh: { label: 'フィールド12', value: '预留10' }, en: { label: 'フィールド12', value: 'Placeholder10' }, ja: { label: 'フィールド12', value: '予約10' } },
            label13: { zh: { label: 'フィールド13', value: '预留11' }, en: { label: 'フィールド13', value: 'Placeholder11' }, ja: { label: 'フィールド13', value: '予約11' } },
            label14: { zh: { label: 'フィールド14', value: '预留12' }, en: { label: 'フィールド14', value: 'Placeholder12' }, ja: { label: 'フィールド14', value: '予約12' } },
            label15: { zh: { label: 'フィールド15', value: '预留13' }, en: { label: 'フィールド15', value: 'Placeholder13' }, ja: { label: 'フィールド15', value: '予約13' } },
            label16: { zh: { label: 'フィールド16', value: '预留14' }, en: { label: 'フィールド16', value: 'Placeholder14' }, ja: { label: 'フィールド16', value: '予約14' } },
            label17: { zh: { label: 'フィールド17', value: '预留15' }, en: { label: 'フィールド17', value: 'Placeholder15' }, ja: { label: 'フィールド17', value: '予約15' } },
            label18: { zh: { label: 'フィールド18', value: '预留16' }, en: { label: 'フィールド18', value: 'Placeholder16' }, ja: { label: 'フィールド18', value: '予約16' } },
            photo1: { zh: { label: '画像1', value: '图片1' }, en: { label: '画像1', value: 'photo1' }, ja: { label: '画像1', value: '画像1' } },
            photo2: { zh: { label: '画像2', value: '图片2' }, en: { label: '画像2', value: 'photo2' }, ja: { label: '画像2', value: '画像2' } },
            photo3: { zh: { label: '画像3', value: '图片3' }, en: { label: '画像3', value: 'photo3' }, ja: { label: '画像3', value: '画像3' } },
            photo4: { zh: { label: '画像4', value: '图片4' }, en: { label: '画像4', value: 'photo4' }, ja: { label: '画像4', value: '画像4' } },
            photo5: { zh: { label: '画像5', value: '图片5' }, en: { label: '画像5', value: 'photo5' }, ja: { label: '画像5', value: '画像5' } }
        },
        labelEditValidMsg: {
            label1: 'フィールド1を入力してください',
            label2: 'フィールド2を入力してください',
            label3: 'フィールド3を入力してください',
            label4: 'フィールド4を入力してください',
            label5: 'フィールド5を入力してください',
            label6: 'フィールド6を入力してください',
            label7: 'フィールド7を入力してください',
            label8: 'フィールド8を入力してください',
            label9: 'フィールド9を入力してください',
            label10: 'フィールド10を入力してください',
            label11: 'フィールド11を入力してください',
            label12: 'フィールド12を入力してください',
            label13: 'フィールド13を入力してください',
            label14: 'フィールド14を入力してください',
            label15: 'フィールド15を入力してください',
            label16: 'フィールド16を入力してください',
            label17: 'フィールド17を入力してください',
            label18: 'フィールド18を入力してください',
            label19: 'フィールド19を入力してください',
            label20: 'フィールド20を入力してください',
            input: '{name}を入力してください',
            sence: 'シーン名を入力してください',
            senceExist: 'シーン名はすでに存在します',
            senceFail: '失敗しました。再入力してください',
            senceLang: 'シーンフィールドの言語を選択してください'
        },
        labelEditTips: {
            getLabelNameFail: 'フィールド名の取得に失敗しました',
            success: 'フィールド名が正常に編集されました',
            fail: 'フィールド名の編集に失敗しました'
        },
        sence: {
            edit: 'シーン編集',
            name: 'シーン名',
            labelLang: 'シーンフィールド言語'
        },
        senceLang: [
            {
                langVal: 'ja',
                langLabel: '日本語',
                editTitle: '日本語フィールド編集'
            },{
                langVal: 'zh',
                langLabel: '中国語',
                editTitle: '中国語フィールド編集'
            },{
                langVal: 'en',
                langLabel: '英語',
                editTitle: '英語フィールド編集'
            }
        ],
        submiting: '提出中...',
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/login.js